import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hw_detail_table_container card-white-6" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("批量填写分成信息")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("编辑")

import { pub_batch_edit_billing, pub_edit_billing_item, get_pub_billing_page } from '@/api/erp-bills';
  import { DialogFormItem } from '@/components/WeDialog/types';
  import { useTable } from '@/components/WeTable';
  import { useApp } from '@/hooks/useApp';
  import { appStore } from '@/store/modules/app';
  import { isEmptyData } from '@/utils/common';
  import dayjs from 'dayjs';
  import { cloneDeep } from 'lodash-es';
  import { computed, ref } from 'vue';

  interface IProps {
    contract_id: number;
    contract: Recordable;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    contract_id: { default: -1 },
    contract: { default: () => ({}) }
  },
  emits: ['updateList'],
  setup(__props: any, { emit }) {

const props = __props as { contract_id: number, contract: Recordable }

  

  const month = ref();
  month.value = dayjs().subtract(1, 'month').format('YYYY-MM');
  const { $showAlert, $showDialog } = useApp();
  const [register, { reload, getSelectRows, clearSelectedRowKeys }] = useTable({
    title: '发行对账',
    columns: [
      {
        title: 'Code',
        dataIndex: 'product__code',
      },
      {
        title: '产品名称',
        dataIndex: 'product__name',
      },
      {
        title: '计入分成',
        dataIndex: 'divide_count_in',
        format: (text) => (text ? '计入' : '不计入'),
      },
      {
        title: '分成类型',
        dataIndex: 'divide_type',
        format: (text) => ({ by_profit: '按盈利', by_revenue: '按收入' }[text]),
      },
      {
        title: '分成比例',
        dataIndex: 'divide_ratio',
        componentType: 'we-number-range',
      },
      {
        title: '操作',
        dataIndex: 'action',
        flag: 'ACTION',
        slots: { customRender: 'action' },
      },
    ],
    rowKey: 'product__code',
    rowSelection: { type: 'checkbox' },
    api: (params) => {
      params.fields.push('product_id');
      params.contract_id = props.contract_id;
      params.month = month.value;
      return get_pub_billing_page(params);
    },
  });

  
  const show_btns = computed(() => {
    let flag = false;
    const find_bill_item = props.contract.bill_list.find((item) => item.month === month.value);
    if (!isEmptyData(find_bill_item)) {
      flag = ['新建', 'AM对账'].includes(find_bill_item.rd_state_name);
    }
    return flag;
  });
  function handleChange() {
    clearSelectedRowKeys();
    appStore.SET_WE_DIALOG(null);
    reload();
    emit('updateList');
  }
  function batchEditDivideInfo() {
    const rows = getSelectRows();
    if (rows.length === 0) {
      $showAlert('警告', '请勾选billing后重试！');
    } else {
      const countInItems = [
        { text: '计入', value: true },
        { text: '不计入', value: false },
      ];
      const divideTypeItems = [
        { text: '按盈利', value: 'by_profit' },
        { text: '按收入', value: 'by_revenue' },
      ];
      const inputs: DialogFormItem[] = [];
      inputs.push({
        type: 'radio',
        label: '是否计入分成',
        result: 'divide_count_in',
        items: countInItems,
        width: 24,
      });
      inputs.push({
        type: 'select',
        label: '分成类型',
        result: 'divide_type',
        show: (result) => !!result.divide_count_in,
        items: divideTypeItems,
        width: 24,
      });
      inputs.push({
        type: 'number',
        label: '分成比例(%)',
        result: 'divide_ratio',
        show: (result) => !!result.divide_count_in,
        width: 24,
        componentProps: {
          formatter: (value) => `${value}%`,
          parser: (value) => value.replace('%', ''),
          min: 0,
          max: 100,
        },
      });
      $showDialog({
        title: '批量填写分成信息',
        width: '500px',
        blocks: [{ type: 'input', value: inputs }],
        callback: (result) => {
          result.divide_ratio = ((result.divide_ratio || 0) / 100.0).toFixed(2);
          handleChange();
          const params = {
            product_ids: rows.map((row) => row.product_id),
            contract_id: props.contract_id,
            month: month.value,
            data: result,
          };
          pub_batch_edit_billing(params).then(() => {
            handleChange();
          });
        },
      });
    }
  }
  function editPubBillingDivide(item, type = 'divide') {
    const divideTypeItems = [
      { text: '按盈利', value: 'by_profit' },
      { text: '按收入', value: 'by_revenue' },
    ];
    const countInItems = [
      { text: '计入', value: true },
      { text: '不计入', value: false },
    ];

    item = cloneDeep(item);

    if (item.grant_ratio) {
      item.grant_ratio = item.grant_ratio * 100.0;
    }
    if (item.divide_ratio) {
      item.divide_ratio = item.divide_ratio * 100.0;
    }

    const title = `编辑${type === 'divide' ? '分成' : '补贴'}: ${item.product_code}`;
    const inputs: DialogFormItem[] = [];
    if (type === 'divide') {
      inputs.push({
        type: 'radio',
        label: '是否计入分成',
        result: 'divide_count_in',
        items: countInItems,
        width: 24,
      });
      inputs.push({
        type: 'select',
        label: '分成类型',
        result: 'divide_type',
        items: divideTypeItems,
        width: 24,
      });
      inputs.push({ type: 'text', label: '分成比例(%)', result: 'divide_ratio', width: 24 });
    } else {
      inputs.push({
        type: 'radio',
        label: '是否计入补贴',
        result: 'grant_count_in',
        items: countInItems,
        width: 24,
      });
      inputs.push({ type: 'text', label: '补贴比例(%)', result: 'grant_ratio', width: 24 });
    }

    $showDialog({
      title: title,
      width: '400px',
      labelCol: '120px',
      init: item,
      blocks: [{ type: 'input', value: inputs }],
      callback: (result) => {
        result.grant_ratio = (result.grant_ratio || 0) / 100.0;
        result.divide_ratio = (result.divide_ratio || 0) / 100.0;
        const params = {
          product_id: item.product_id,
          contract_id: props.contract_id,
          month: month.value,
          data: result,
        };
        pub_edit_billing_item(params).then(() => {
          handleChange();
        });
      },
    });
  }

return (_ctx: any,_cache: any) => {
  const _component_a_month_picker = _resolveComponent("a-month-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_AButton = _resolveComponent("AButton")!
  const _component_WeTable = _resolveComponent("WeTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_WeTable, { onRegister: _unref(register) }, {
      headerButton: _withCtx(() => [
        _createVNode(_component_a_month_picker, {
          allowClear: "",
          value: month.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((month).value = $event)),
          valueFormat: "YYYY-MM",
          onChange: _unref(reload)
        }, null, 8, ["value", "onChange"]),
        (_unref(show_btns))
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              type: "primary",
              class: "ml-8",
              onClick: batchEditDivideInfo
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      action: _withCtx(({ record }) => [
        (_unref(show_btns))
          ? (_openBlock(), _createBlock(_component_AButton, {
              key: 0,
              type: "link",
              onClick: ($event: any) => (editPubBillingDivide(record))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onRegister"])
  ]))
}
}

})